var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-operational-disturbances"},[_c('h1',[_vm._v(_vm._s(_vm.title ? _vm.title : _vm.translations.title))]),_c('HitCount'),_c('HitList'),(_vm.showMore)?_c('ShowMore'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }